import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Đầu trang: tiêu đề + hành động. Hết.
 *
 * CHỦ Ý không có prop `subtitle` và không có prop `eyebrow`. Tiêu đề tự đứng
 * được; một dòng phụ diễn giải lại chính nó chỉ làm người dùng đọc hai lần.
 * Thông tin thật sự cần thì thuộc về nội dung trang, không thuộc về đầu trang.
 *
 * `<h1>` để trần — cỡ chữ do `.app-content h1` quy định, một chỗ duy nhất.
 *
 * Dưới `lg`, tiêu đề chỉ còn cho trình đọc màn hình: thanh trên của
 * DashboardLayout đã nói đang ở trang nào, in lại lần nữa là lấy mất dòng
 * đầu tiên của màn hình điện thoại để nói một điều vừa nói xong.
 */
export function PageHeader({
  title,
  actions,
  className,
}: {
  title: ReactNode
  actions?: ReactNode
  className?: string
}) {
  return (
    <div data-slot="page-head" className={cn('flex flex-wrap items-center justify-between gap-x-4 gap-y-3', className)}>
      <h1 className="min-w-0 sr-only lg:not-sr-only">{title}</h1>
      {/* max-w-full: hàng hành động rộng hơn màn (vd. 5 nút kỳ báo cáo) xuống dòng / co lại, không nới cả trang */}
      {actions && <div className="ml-auto flex max-w-full shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  )
}
